import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/common.css';
import './styles/main.css';
import './assets/icon/iconfont.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);